
import { WorldCountry } from '../types';
import { indiaAdditionalCities } from './indiaExpansion';
import { indiaAdditionalCities2 } from './indiaExpansion2';
import { indiaAdditionalCities3 } from './indiaExpansion3';

export const indiaData: WorldCountry = {
  name: 'India',
  slug: 'india',
  code: 'IN',
  population: 1380000000,
  topCities: [
    { name: 'Mumbai', slug: 'mumbai', population: 20411274 },
    { name: 'Delhi', slug: 'delhi', population: 16787941 },
    { name: 'Bangalore', slug: 'bangalore', population: 8443675 },
    { name: 'Hyderabad', slug: 'hyderabad', population: 6809970 },
    { name: 'Ahmedabad', slug: 'ahmedabad', population: 5570585 },
    { name: 'Chennai', slug: 'chennai', population: 4681087 },
    { name: 'Kolkata', slug: 'kolkata', population: 4496694 },
    { name: 'Surat', slug: 'surat', population: 4467797 },
    { name: 'Pune', slug: 'pune', population: 3124458 },
    { name: 'Jaipur', slug: 'jaipur', population: 3046163 },
    { name: 'Lucknow', slug: 'lucknow', population: 2817105 },
    { name: 'Kanpur', slug: 'kanpur', population: 2767031 },
    { name: 'Nagpur', slug: 'nagpur', population: 2405665 },
    { name: 'Indore', slug: 'indore', population: 1964086 },
    { name: 'Thane', slug: 'thane-india', population: 1841128 },
    { name: 'Bhopal', slug: 'bhopal', population: 1798218 },
    { name: 'Visakhapatnam', slug: 'visakhapatnam', population: 1730320 },
    { name: 'Pimpri-Chinchwad', slug: 'pimpri-chinchwad', population: 1729359 },
    { name: 'Patna', slug: 'patna', population: 1684222 },
    { name: 'Vadodara', slug: 'vadodara', population: 1666703 },
    { name: 'Ghaziabad', slug: 'ghaziabad-india', population: 1636068 },
    { name: 'Ludhiana', slug: 'ludhiana', population: 1618879 },
    { name: 'Agra', slug: 'agra', population: 1585704 },
    { name: 'Nashik', slug: 'nashik', population: 1486973 },
    { name: 'Faridabad', slug: 'faridabad', population: 1404653 },
    { name: 'Meerut', slug: 'meerut', population: 1305429 },
    { name: 'Rajkot', slug: 'rajkot', population: 1286995 },
    { name: 'Vasai-Virar', slug: 'vasai-virar', population: 1221233 },
    { name: 'Varanasi', slug: 'varanasi', population: 1201815 },
    { name: 'Srinagar', slug: 'srinagar', population: 1180570 },
    { name: 'Aurangabad', slug: 'aurangabad', population: 1171330 },
    { name: 'Dhanbad', slug: 'dhanbad', population: 1161561 },
    { name: 'Amritsar', slug: 'amritsar-india', population: 1132761 },
    { name: 'Navi Mumbai', slug: 'navi-mumbai', population: 1119477 },
    { name: 'Allahabad', slug: 'allahabad', population: 1117094 },
    { name: 'Ranchi', slug: 'ranchi', population: 1073440 },
    { name: 'Howrah', slug: 'howrah', population: 1072161 },
    { name: 'Coimbatore', slug: 'coimbatore', population: 1061447 },
    { name: 'Jabalpur', slug: 'jabalpur', population: 1055525 },
    { name: 'Gwalior', slug: 'gwalior', population: 1054420 },
    { name: 'Vijayawada', slug: 'vijayawada', population: 1048240 },
    { name: 'Jodhpur', slug: 'jodhpur', population: 1033756 },
    { name: 'Madurai', slug: 'madurai', population: 1017865 },
    { name: 'Raipur', slug: 'raipur', population: 1010087 },
    { name: 'Kota', slug: 'kota-india', population: 1001365 },
    { name: 'Chandigarh', slug: 'chandigarh-india', population: 1025682 },
    { name: 'Guwahati', slug: 'guwahati-india', population: 963429 },
    { name: 'Solapur', slug: 'solapur-india', population: 951558 },
    { name: 'Hubli-Dharwad', slug: 'hubli-dharwad', population: 943857 },
    { name: 'Thiruvananthapuram', slug: 'thiruvananthapuram', population: 957730 },
    { name: 'Mysore', slug: 'mysore', population: 920550 },
    ...indiaAdditionalCities,
    ...indiaAdditionalCities2,
    ...indiaAdditionalCities3
  ]
};

export const southAsiaCountries = [
  indiaData,
  {
    name: 'Pakistan',
    slug: 'pakistan',
    code: 'PK',
    population: 220892000,
    topCities: [
      { name: 'Karachi', slug: 'karachi', population: 14910352 },
      { name: 'Lahore', slug: 'lahore', population: 11126285 },
      { name: 'Faisalabad', slug: 'faisalabad', population: 3203846 },
      { name: 'Rawalpindi', slug: 'rawalpindi', population: 2098231 },
      { name: 'Gujranwala', slug: 'gujranwala', population: 2027001 },
      { name: 'Peshawar', slug: 'peshawar', population: 1970042 },
      { name: 'Multan', slug: 'multan', population: 1871843 },
      { name: 'Hyderabad', slug: 'hyderabad-pakistan', population: 1734309 },
      { name: 'Islamabad', slug: 'islamabad', population: 1014825 },
      { name: 'Quetta', slug: 'quetta', population: 1001205 }
    ]
  },
  {
    name: 'Bangladesh',
    slug: 'bangladesh',
    code: 'BD',
    population: 164689000,
    topCities: [
      { name: 'Dhaka', slug: 'dhaka', population: 8906039 },
      { name: 'Chittagong', slug: 'chittagong', population: 2592439 },
      { name: 'Sylhet', slug: 'sylhet', population: 526412 },
      { name: 'Khulna', slug: 'khulna', population: 663342 },
      { name: 'Rajshahi', slug: 'rajshahi', population: 449756 },
      { name: 'Comilla', slug: 'comilla', population: 389411 },
      { name: 'Rangpur', slug: 'rangpur', population: 343122 },
      { name: 'Narayanganj', slug: 'narayanganj', population: 543090 },
      { name: 'Gazipur', slug: 'gazipur', population: 1777429 },
      { name: 'Mymensingh', slug: 'mymensingh', population: 389411 }
    ]
  },
  {
    name: 'Sri Lanka',
    slug: 'sri-lanka',
    code: 'LK',
    population: 21413000,
    topCities: [
      { name: 'Colombo', slug: 'colombo', population: 752993 },
      { name: 'Dehiwala-Mount Lavinia', slug: 'dehiwala-mount-lavinia', population: 245974 },
      { name: 'Moratuwa', slug: 'moratuwa', population: 207755 },
      { name: 'Negombo', slug: 'negombo', population: 142449 },
      { name: 'Kandy', slug: 'kandy', population: 125351 },
      { name: 'Kalmunai', slug: 'kalmunai', population: 106783 },
      { name: 'Vavuniya', slug: 'vavuniya', population: 99653 },
      { name: 'Galle', slug: 'galle', population: 99478 },
      { name: 'Trincomalee', slug: 'trincomalee', population: 99135 },
      { name: 'Batticaloa', slug: 'batticaloa', population: 95489 }
    ]
  },
  {
    name: 'Nepal',
    slug: 'nepal',
    code: 'NP',
    population: 29137000,
    topCities: [
      { name: 'Kathmandu', slug: 'kathmandu', population: 1442271 },
      { name: 'Pokhara', slug: 'pokhara', population: 518452 },
      { name: 'Lalitpur', slug: 'lalitpur-nepal', population: 294329 },
      { name: 'Bharatpur', slug: 'bharatpur-nepal', population: 280502 },
      { name: 'Biratnagar', slug: 'biratnagar', population: 242548 },
      { name: 'Birgunj', slug: 'birgunj', population: 204949 },
      { name: 'Dharan', slug: 'dharan', population: 173096 },
      { name: 'Hetauda', slug: 'hetauda', population: 152875 },
      { name: 'Nepalgunj', slug: 'nepalgunj', population: 141178 },
      { name: 'Butwal', slug: 'butwal', population: 138742 }
    ]
  }
];
